// Royal guard paramater
const PLAYER_ROYAL_GUARD = "@ROYAL_GUARD";
const PLAYER_NAME_RG = "Royal Guard";
const SKILL_TYPE_RG = "@HOLY_CROSS";
const SKILL_NAME_RG = "ホーリークロス";
const SKILL_AREA_RG = [{ posX: 0, posY: 0 }, { posX: -1, posY: 0 }, { posX: 0, posY: -1 }, { posX: 1, posY: 0 }, { posX: 0, posY: 1 }];
const SKILL_DAMAGE_RG = 1;
const SKILL_COOL_TIME_RG = 3;

const PLAYER_KAGEROU = "@KAGEROU";
const PLAYER_NAME_KG = "Kagerou";
const SKILL_TYPE_KG = "@BAKURETSU";
const SKILL_NAME_KG = "爆裂苦無";
const SKILL_AREA_KG = [{ posX: 0, posY: 0 }, { posX: -1, posY: 0 }, { posX: -1, posY: -1 },
{ posX: 0, posY: -1 }, { posX: 1, posY: -1 }, { posX: 1, posY: 0 },
{ posX: -1, posY: 1 }, { posX: 0, posY: 1 }, { posX: 1, posY: 1 }];
const SKILL_DAMAGE_KG = 2;
const SKILL_COOL_TIME_KG = 12;

const PLAYER_SUMMONER = "@SUMMONER";
const PLAYER_NAME_SM = "Summoner";
const SKILL_TYPE_SM = "@MATATABI";
const SKILL_NAME_SM = "マタタビランス";
const SKILL_AREA_SM = [{ posX: 0, posY: 0 }, { posX: 0, posY: -1 }];
const SKILL_DAMAGE_SM = 3;
const SKILL_COOL_TIME_SM = 5;

const getPlayerData = charactor => {
    switch (charactor) {
        case PLAYER_ROYAL_GUARD:
            return {
                playerName: PLAYER_NAME_RG,
                skill: SKILL_TYPE_RG,
                skillName: SKILL_NAME_RG,
                skillCoolTime: SKILL_COOL_TIME_RG,
                skillArea: SKILL_AREA_RG,
                skillDamage: SKILL_DAMAGE_RG
            }
        case PLAYER_KAGEROU:
            return {
                playerName: PLAYER_NAME_KG,
                skill: SKILL_TYPE_KG,
                skillName: SKILL_NAME_KG,
                skillCoolTime: SKILL_COOL_TIME_KG,
                skillArea: SKILL_AREA_KG,
                skillDamage: SKILL_DAMAGE_KG
            }
        case PLAYER_SUMMONER:
            return {
                playerName: PLAYER_NAME_SM,
                skill: SKILL_TYPE_SM,
                skillName: SKILL_NAME_SM,
                skillCoolTime: SKILL_COOL_TIME_SM,
                skillArea: SKILL_AREA_SM,
                skillDamage: SKILL_DAMAGE_SM
            }
        default:
            return;
    }
}

export default {
    PLAYER_ROYAL_GUARD,
    PLAYER_NAME_RG,
    SKILL_TYPE_RG,
    SKILL_NAME_RG,
    SKILL_AREA_RG,
    SKILL_DAMAGE_RG,
    SKILL_COOL_TIME_RG,
    PLAYER_KAGEROU,
    PLAYER_NAME_KG,
    SKILL_TYPE_KG,
    SKILL_NAME_KG,
    SKILL_AREA_KG,
    SKILL_DAMAGE_KG,
    SKILL_COOL_TIME_KG,
    PLAYER_SUMMONER,
    PLAYER_NAME_SM,
    SKILL_TYPE_SM,
    SKILL_NAME_SM,
    SKILL_AREA_SM,
    SKILL_DAMAGE_SM,
    SKILL_COOL_TIME_SM,
    getPlayerData
}